export default __webpack_public_path__ + "static/media/tour.8dfc8aaf.svg";